import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {NumberBox} from "devextreme-react/number-box";
import {useRef} from "react";

export function DepthPopupControl() {
    const adapterContext = useEEToolAdapterContext()
    const refSelDepth = useRef<NumberBox>(null);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            adapterContext.handleSelDepth(refSelDepth.current?.instance.option("value") ?? 0, adapterContext.selDepthOptionalProduct);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupSelDepth()
    };

    if (!adapterContext.popupSelDepthVisible)
        return <></>;

    return (
        <>
            <Popup
                title='Enter Depth'
                visible={adapterContext.popupSelDepthVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupSelDepth()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.selDepth}
                            width={'100%'}
                            label='Depth'
                            labelMode={'outside'}
                            ref={refSelDepth}
                        />
                    </div>
                    <div className="dx-field">
                        <SelectBox
                            label={"Type:"}
                            labelMode={'outside'}
                            width={'100%'}
                            dataSource={adapterContext.selDepthOptionalProducts}
                            displayExpr="Description"
                            valueExpr="Id"
                            value={adapterContext.selDepthOptionalProduct}
                            visible={adapterContext.popupSelDepthOptionalProductsVisible}
                            onValueChanged={(e) => adapterContext.setSelDepthOptionalProduct(e.value)}
                            searchEnabled={false}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
